// Only transport failures may retain an already-authorized playback session.
// Permission errors and unknown failures keep the existing blocking behavior.
export function isTransientCourseRefreshError(error) {
  const code = String(error?.code || "").replace(/^(firestore|auth|functions)\//, "");
  return ["unavailable", "deadline-exceeded", "network-request-failed"].includes(code);
}
